import { Alert, Button } from '@mui/material';
import { useContext } from 'react';
import { BudgetMonthContext } from './BudgetMonthContextProvider';

const BudgetMonthSetupAlert = () => {
  const { setIsEditing } = useContext(BudgetMonthContext);

  const handleSetEditing = () => {
    setIsEditing(true);
  };

  return (
    <Alert
      severity="info"
      action={
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={handleSetEditing}
        >
          Setup Budget Month
        </Button>
      }
      sx={{ mb: 2 }}
    >
      Set up your budgets for this month.
    </Alert>
  );
};

export default BudgetMonthSetupAlert;
